export const HEADQUARTERS = 'headquarters';
export const STORE_LOCATIONS = 'store_locations';
export const PACKAGE_SELECTION = 'package_selection';
export const PACKAGES = 'packages';
export const ADMINISTRATORS = 'administrators';
export const IS_SHOPPING_MALL = 'isShoppingMall';
